import { stripMarkdown } from '@terminal/views/alfred/research/utils/stripMarkdown';

export const extractContentPreview = (markdown: string): string => {
  const match = markdown.match(/^#{1,6}\s+(.+)/);

  if (match?.[1]) {
    return stripMarkdown(match[1]);
  }

  const plain = stripMarkdown(markdown);
  const sentences = plain.match(/^(?:[^.!?]+[.!?]\s*){1,2}/);
  if (sentences?.[0]) {
    return sentences[0].trim();
  }

  // Fallback for content without headings or sentence terminators
  // (e.g. short numeric answers like "16" or "100 + 100 = 200")
  return plain;
};
